// ---------------------------------------------------------------------------
// Prezio Onboard Widget — LogoBar
// ---------------------------------------------------------------------------
// Displays the retailer logo (during retailer flow) or host-configured logo
// below the ProgressBar. Renders nothing when no logo is available.
// ---------------------------------------------------------------------------

import { memo } from 'react';
import { useSessionState } from '@/hooks/useSession';
import { useRetailerLogo } from '@/hooks/useRetailerLogo';
import { useTheme } from '@/hooks/useTheme';
import styles from './LogoBar.module.css';

export const LogoBar = memo(function LogoBar() {
  const { session } = useSessionState();
  const { logo: hostLogo } = useTheme();
  const retailerLogo = useRetailerLogo(session?.current_step ?? null);
  const logoUrl = retailerLogo ?? hostLogo;

  if (!logoUrl) return null;

  return (
    <div className={styles['wrapper']}>
      <img src={logoUrl} alt="Logo" className={styles['logo']} />
    </div>
  );
});
